import { render, staticRenderFns } from "./selectProgram.vue?vue&type=template&id=9d67ed54"
import script from "./selectProgram.vue?vue&type=script&lang=js"
export * from "./selectProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports